import React, { FC } from 'react';
import { BaseIcon } from '../BaseIcon';
import { ThemeIconProps } from '../types';

export const ThemeIcon: FC<ThemeIconProps> = (props) => <BaseIcon {...props} variant="theme" />;
